// extracted by mini-css-extract-plugin
module.exports = {"downloadContainer":"download_downloadContainer__Q_hmf","downloadFooter":"download_downloadFooter__gIEJI"};